// Find components downward
export function findComponentsDownward(context: any, componentName: any) {
    return context.$children.reduce((components: any, child: any) => {
        // console.log(child.$options, 'options');
        // console.log(child.$options.name, 'name');
        // console.log(child.$options._componentTag, '_componentTag');
        if (child.$options.name === componentName || child.$options._componentTag === componentName) { components.push(child); }
        const foundChilds = findComponentsDownward(child, componentName);
        return components.concat(foundChilds);
    }, []);
}

// Find components upward
export function findComponentsUpward(context: any, componentName: any): any {
    const parents: any[] = [];
    const parent = context.$parent;
    if (parent) {
        if (parent.$options.name === componentName || parent.$options._componentTag === componentName) { parents.push(parent); }
        return parents.concat(findComponentsUpward(parent, componentName));
    } else {
        return [];
    }
}

// Find brothers components
export function findBrothersComponents(context: any, componentName: any, exceptMe = true) {
    const res = context.$parent.$children.filter((item: any) => {
        return item.$options.name === componentName;
    });
    const index = res.findIndex((item: any) => item._uid === context._uid);
    if (exceptMe) { res.splice(index, 1); }
    return res;
}

export async function isHasImg(pathImg: any) {
    const ImgObj: any = new Image();
    ImgObj.src = pathImg;
    await new Promise((resolve, reject) => {
        ImgObj.onload = () => {
            resolve(1);
        };
    });
    // console.log(ImgObj, 'ImgObj');
    // console.log(ImgObj.fileSize, ImgObj.width, ImgObj.height, 'img');
    if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        return true;
    } else {
        return false;
    }
}
